import { apiGet, apiPost } from "./client";
import type { LoginRequest, LoginResponse, Me } from "@/types/auth";

export function login(body: LoginRequest): Promise<LoginResponse> {
  return apiPost<LoginResponse>("/api/login", body);
}

export function logout(): Promise<{ ok: boolean }> {
  return apiPost<{ ok: boolean }>("/api/logout");
}

export function getMe(): Promise<Me> {
  return apiGet<Me>("/api/me");
}
